import { RawStabilityPresentation } from "../types/api/drill";
import { StabilityPresentation } from "../types/ui/weaponPresentation";



export function toStabilityPresentation(
  raw: RawStabilityPresentation
): StabilityPresentation {
  const startTime = raw.stability_plot[0]?.time ?? 0;

  return {
    stability_plot: raw.stability_plot.map((p) => ({
      time: Math.round((p.time - startTime) * 1000),
      sight_picture_angle: p.sight_picture_angle,
      rotation_speed: p.rotation_speed,
      convergence: p.convergence_far ? 1 : 0,
      convergence_color: p.convergence_far ? "green" : "red",
    })),
    repetition_events: raw.repetition_events.map((e) => ({
      time: Math.round((e.time - startTime) * 1000),
      event: e.event,
    })),
  };
}